var map = {
	"./20221207_072102_856_4096_2730.bmp": 6525,
	"./AllSupportedBarcodeTypes.png": 9984,
	"./AllSupportedBarcodeTypes2.png": 521,
	"./BarcodeColorMode.png": 9912,
	"./BarcodeOrientation.png": 2840,
	"./DamagedBarcodes.png": 7994,
	"./GS1 DataBar.png": 3827,
	"./GeneralBarcodes.png": 5032,
	"./PatchCode.png": 9626,
	"./Pharmacode.png": 8241,
	"./PostalCode.png": 3355,
	"./batch-scan.jpg": 6007,
	"./blurryEffect_DPM.png": 3433,
	"./both.gif": 922,
	"./dbr-logo-32x32.png": 5925,
	"./dynamsoft-logo.png": 1993,
	"./faq-right-down.png": 4449,
	"./faq-right-up.png": 1697,
	"./image.png": 7752,
	"./inverted.gif": 4157,
	"./ipt-1dFormat.gif": 6413,
	"./ipt-Aztec.gif": 8756,
	"./ipt-DataMatrix.gif": 6221,
	"./ipt-GS1COMPOSITE.gif": 4625,
	"./ipt-GS1DatabarFormat.gif": 7582,
	"./ipt-Maxicode.gif": 9501,
	"./ipt-Patch.gif": 8195,
	"./ipt-QRCode.gif": 3890,
	"./ipt-dotCode.gif": 7153,
	"./ipt-pdf417.gif": 7709,
	"./ipt-pharmaCodeFormat.gif": 4567,
	"./ipt-postalCodeFormat.gif": 9258,
	"./normal.gif": 9120,
	"./slide 1.png": 7918,
	"./slider-bar.png": 432,
	"./slider-thum.png": 4698,
	"./supports-DPM-DataMatrix.gif": 5089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9300;